import React from "react";
import { Avatar, Button } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import CloseIcon from "@mui/icons-material/Close";

export const CreateEventConflictPanel = ({
  empty = false,
  conflicts = [],
  isScheduleConflict = false,
  selectedConflictDate = "—",
  isLoading = false,
  onClose,
  onBackToSelection,
  onRemoveConflict,
  onRemoveAndContinue,
}) => (
  <div>
    <div className="create-promo-invite-modal__head">
      <h2 id="create-event-wizard-title">Create Event</h2>
      <button
        type="button"
        className="create-promo-invite-modal__close"
        onClick={onClose}
        disabled={isLoading}
        aria-label="Close"
      >
        <CloseIcon sx={{ fontSize: 18 }} />
      </button>
    </div>
    <div className="create-promo-invite-modal__separator" />

    {empty ? (
      <div className="create-promo-invite-modal__conflict-block">
        <div className="create-promo-invite-modal__alert" role="alert">
          <WarningAmberRoundedIcon
            className="create-promo-invite-modal__alert-icon"
            fontSize="small"
          />
          <div>
            <p className="create-promo-invite-modal__alert-title">
              No Employees Selected
            </p>
            <p className="create-promo-invite-modal__alert-message">
              Your previous conflict removals have left this invitation list
              empty.
            </p>
          </div>
        </div>
        <div className="create-promo-invite-modal__empty">
          <PersonOutlineRoundedIcon
            className="create-promo-invite-modal__empty-icon"
            fontSize="large"
          />
          <p className="create-promo-invite-modal__empty-title">
            An invitation must contain at least one employee.
          </p>
          <p className="create-promo-invite-modal__empty-copy">
            Please return to the selection list to select additional eligible
            employees who do not have conflicting events.
          </p>
        </div>
      </div>
    ) : (
      <div className="create-promo-invite-modal__conflict-block">
        <div className="create-promo-invite-modal__alert" role="alert">
          <WarningAmberRoundedIcon
            className="create-promo-invite-modal__alert-icon"
            fontSize="small"
          />
          <div>
            <p className="create-promo-invite-modal__alert-title">
              {isScheduleConflict
                ? "Scheduling Conflict Detected"
                : "Conflicting Assignment Detected"}
            </p>
            <p className="create-promo-invite-modal__alert-message">
              {isScheduleConflict
                ? "An employee is already booked for another event on your selected promotion date."
                : "An employee in your selection is already assigned to an active event for this book under a different Super Admin."}
            </p>
          </div>
        </div>

        {isScheduleConflict && (
          <>
            <p className="create-promo-invite-modal__conflict-label">
              Selected Date
            </p>
            <div className="create-promo-invite-modal__selected-date">
              {selectedConflictDate}
            </div>
          </>
        )}

        <p className="create-promo-invite-modal__conflict-label">
          Conflicting Employee
        </p>
        <div className="create-promo-invite-modal__conflict-list">
          {conflicts.map((conflict) => (
            <div
              key={conflict.promotionId}
              className="create-promo-invite-modal__conflict-card"
            >
              <div className="create-promo-invite-modal__conflict-info">
                <Avatar
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: "var(--grey300, #d0d5dd)",
                    fontSize: 14,
                  }}
                >
                  {(conflict.employee?.name || "?").charAt(0)}
                </Avatar>
                <div>
                  <p className="create-promo-invite-modal__conflict-name">
                    {conflict.employee?.name || "Unknown employee"}
                  </p>
                  <p className="create-promo-invite-modal__conflict-meta">
                    {isScheduleConflict
                      ? `Clashes with event: "${
                          conflict.conflictingEvent?.name || "another event"
                        }" (${
                          conflict.conflictingEvent?.bookName || "another book"
                        })`
                      : `Assigned by Super Admin: ${
                          conflict.assignedBy?.name || "Unknown"
                        }`}
                  </p>
                </div>
              </div>
              <Button
                type="button"
                variant="outlined"
                color="error"
                size="small"
                startIcon={<DeleteOutlineIcon />}
                className="create-promo-invite-modal__remove-btn"
                onClick={() => onRemoveConflict?.(conflict.promotionId)}
                disabled={isLoading}
              >
                Remove Employee
              </Button>
            </div>
          ))}
        </div>
      </div>
    )}

    <div className="create-promo-invite-modal__actions">
      <Button
        type="button"
        className="create-promo-invite-modal__btn-cancel"
        variant="contained"
        disableElevation
        onClick={onClose}
        disabled={isLoading}
      >
        Cancel
      </Button>
      {empty ? (
        <Button
          type="button"
          className="create-promo-invite-modal__btn-primary"
          variant="contained"
          disableElevation
          onClick={onBackToSelection}
        >
          Go Back to Selection
        </Button>
      ) : (
        <Button
          type="button"
          className="create-promo-invite-modal__btn-primary"
          variant="contained"
          disableElevation
          onClick={onRemoveAndContinue}
          disabled={isLoading}
        >
          {isLoading ? "Creating…" : "Remove & Continue"}
        </Button>
      )}
    </div>
  </div>
);
